export default {
  section101: [
    { rowName: "Row 9", rowPath: "VR_Section_101_9_10" },
    { rowName: "Row 16", rowPath: "VR_Section_101_16_13" },
  ],
  section102: [
    { rowName: "Row 9", rowPath: "VR_Section_102_9_10" },
    { rowName: "Row 16", rowPath: "VR_Section_102_16_23" },
  ],
  section103Top: [
    { rowName: "Row 25", rowPath: "VR_Section_103_25_12" },
  ],
  section104Top: [
    { rowName: "Row 25", rowPath: "VR_Section_104_25_2" },
  ],
  section105Top: [
    { rowName: "Row 25", rowPath: "VR_Section_105_25_12" },
  ],
  section103: [
    { rowName: "Row 7", rowPath: "VR_Section_103_7_7" },
    { rowName: "Row 16", rowPath: "VR_Section_103_16_12" },
  ],
  section104: [
    { rowName: "Row 9", rowPath: "VR_Section_104_9_10" },
    { rowName: "Row 16", rowPath: "VR_Section_104_16_11" },
  ],
  section105: [
    { rowName: "Row 7", rowPath: "VR_Section_105_7_17" },
    { rowName: "Row 16", rowPath: "VR_Section_105_16_12" },
  ],
  section106: [
    { rowName: "Row 9", rowPath: "VR_Section_106_9_10" },
    { rowName: "Row 16", rowPath: "VR_Section_106_16_7" },
  ],
  section107: [
    { rowName: "Row 9", rowPath: "VR_Section_107_9_7" },
    { rowName: "Row 16", rowPath: "VR_Section_107_16_10" },
  ],
  section108: [
    { rowName: "Row 9", rowPath: "VR_Section_108_9_8" },
    { rowName: "Row 16", rowPath: "VR_Section_108_16_10" },
  ],
  section109: [
    { rowName: "Row 9", rowPath: "VR_Section_109_9_7" },
    { rowName: "Row 16", rowPath: "VR_Section_109_16_7" },
  ],
  section110: [
    { rowName: "Row 9", rowPath: "VR_Section_110_9_7" },
    { rowName: "Row 16", rowPath: "VR_Section_110_16_10" },
  ],
  section111: [
    { rowName: "Row 9", rowPath: "VR_Section_111_9_2" },
    { rowName: "Row 16", rowPath: "VR_Section_111_16_10" },
  ],
  section112: [
    { rowName: "Row 9", rowPath: "VR_Section_112_9_6" },
    { rowName: "Row 16", rowPath: "VR_Section_112_16_10" },
  ],
  section113: [
    { rowName: "Row 7", rowPath: "VR_Section_113_7_9" },
    { rowName: "Row 16", rowPath: "VR_Section_113_16_8" },
  ],
  section114: [
    { rowName: "Row 7", rowPath: "VR_Section_114_7_7" },
    { rowName: "Row 16", rowPath: "VR_Section_114_16_9" },
  ],
  section115: [
    { rowName: "Row 7", rowPath: "VR_Section_115_7_9" },
    { rowName: "Row 16", rowPath: "VR_Section_115_16_9" },
  ],
  section116: [
    { rowName: "Row 7", rowPath: "VR_Section_116_7_7" },
    { rowName: "Row 16", rowPath: "VR_Section_116_16_8" },
  ],
  section117: [
    { rowName: "Row 9", rowPath: "VR_Section_117_9_7" },
    { rowName: "Row 16", rowPath: "VR_Section_117_16_9" },
  ],
  section118: [
    { rowName: "Row 9", rowPath: "VR_Section_118_9_7" },
    { rowName: "Row 16", rowPath: "VR_Section_118_16_10" },
  ],
  section119: [
    { rowName: "Row 9", rowPath: "VR_Section_119_5_5" },
    { rowName: "Row 16", rowPath: "VR_Section_119_9_6" },
  ],
  section120: [
    { rowName: "Row 9", rowPath: "VR_Section_120_5_8" },
    { rowName: "Row 16", rowPath: "VR_Section_120_9_8" },
  ],
  section121: [
    { rowName: "Row 9", rowPath: "VR_Section_121_5_4" },
    { rowName: "Row 16", rowPath: "VR_Section_121_9_6" },
  ],
  section201A: [
    { rowName: "Row 3", rowPath: "VR_Section_201A_3_3" },
    { rowName: "Row 8", rowPath: "VR_Section_201A_8_3" },
  ],
  section201B: [{ rowName: "Row 3", rowPath: "VR_Section_201B_3_8" }],
  section202: [{ rowName: "Row 3", rowPath: "VR_Section_202_3_10" }],
  section203: [{ rowName: "Row 3", rowPath: "VR_Section_203_3_9" }],
  section204: [{ rowName: "Row 3", rowPath: "VR_Section_204_3_10" }],
  section205: [{ rowName: "Row 3 WC", rowPath: "VR_Section_205WC_3WC_9" }],
  section206: [{ rowName: "Row 3", rowPath: "VR_Section_206_3_10" }],
  section207: [{ rowName: "Row 3", rowPath: "VR_Section_207_3_12" }],
  section208: [{ rowName: "Row 3", rowPath: "VR_Section_208_3_12" }],
  section209: [{ rowName: "Row 3", rowPath: "VR_Section_209_3_9" }],
  section210: [{ rowName: "Row 3 WC", rowPath: "VR_Section_210WC_3WC_6" }],
  section211: [{ rowName: "Row 3", rowPath: "VR_Section_211_3_9" }],
  section212: [{ rowName: "Row 3", rowPath: "VR_Section_212_3_7" }],
  section213: [{ rowName: "Row 3", rowPath: "VR_Section_213_3_11" }],
  section214: [{ rowName: "Row 3 WC", rowPath: "VR_Section_214WC_3WC_10" }],
  section215: [{ rowName: "Row 3", rowPath: "VR_Section_215_3_10" }],
  section216: [{ rowName: "Row 3", rowPath: "VR_Section_216_3_9" }],
  section217: [{ rowName: "Row 3 WC", rowPath: "VR_Section_217WC_3WC_7" }],
  section218: [{ rowName: "Row 3", rowPath: "VR_Section_218_3_9" }],
  section219: [{ rowName: "Row 3", rowPath: "VR_Section_219_3_10" }],
  section220: [{ rowName: "Row 3", rowPath: "VR_Section_220_3_13" }],
  section221: [{ rowName: "Row 3", rowPath: "VR_Section_221_3_10" }],
  section222: [{ rowName: "Row 3 WC", rowPath: "VR_Section_222WC_3WC_10" }],
  section223: [{ rowName: "Row 3", rowPath: "VR_Section_223_3_9" }],
  section224: [{ rowName: "Row 3", rowPath: "VR_Section_224_3_8" }],
  section225: [{ rowName: "Row 3", rowPath: "VR_Section_225_3_10" }],
  section226A: [{ rowName: "Row 3", rowPath: "VR_Section_226A_3_5" }],
  section226B: [
    { rowName: "Row 3", rowPath: "VR_Section_226B_3_4" },
    { rowName: "Row 8", rowPath: "VR_Section_226B_8_5" },
  ],
  section227: [
    { rowName: "Row 3", rowPath: "VR_Section_227_3_7" },
    { rowName: "Row 8", rowPath: "VR_Section_227_8_9" },
  ],
  section228: [{ rowName: "Row 3", rowPath: "VR_Section_228_3_8" }],
  section230: [{ rowName: "Row 3", rowPath: "VR_Section_230_3_7" }],
  section231: [
    { rowName: "Row 3", rowPath: "VR_Section_231_3_7" },
    { rowName: "Row 8", rowPath: "VR_Section_231_8_9" },
  ],
  section301: [
    { rowName: "Row 1", rowPath: "VR_Section_301_1_5" },
    { rowName: "Row 6", rowPath: "VR_Section_301_6_4" },
  ],
  section302: [
    { rowName: "Row 1", rowPath: "VR_Section_302_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_302_6_10" },
  ],
  section303: [
    { rowName: "Row 1", rowPath: "VR_Section_303_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_303_6_10" },
  ],
  section304: [
    { rowName: "Row 1", rowPath: "VR_Section_304_1_11" },
    { rowName: "Row 6", rowPath: "VR_Section_304_6_11" },
  ],
  section305: [
    { rowName: "Row 1", rowPath: "VR_Section_305_1_13" },
    { rowName: "Row 6", rowPath: "VR_Section_305_6_12" },
  ],
  section306: [
    { rowName: "Row 1", rowPath: "VR_Section_306_1_13" },
    { rowName: "Row 6", rowPath: "VR_Section_306_6_13" },
  ],
  section307: [
    { rowName: "Row 1", rowPath: "VR_Section_307_1_12" },
    { rowName: "Row 6", rowPath: "VR_Section_307_6_12" },
  ],
  section308: [
    { rowName: "Row 1", rowPath: "VR_Section_308_1_11" },
    { rowName: "Row 6", rowPath: "VR_Section_308_6_11" },
  ],
  section309: [
    { rowName: "Row 1", rowPath: "VR_Section_309_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_309_6_10" },
  ],
  section310: [
    { rowName: "Row 1", rowPath: "VR_Section_310_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_310_6_10" },
  ],
  section311: [
    { rowName: "Row 1", rowPath: "VR_Section_311_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_311_6_10" },
  ],
  section312: [
    { rowName: "Row 1", rowPath: "VR_Section_312_1_11" },
    { rowName: "Row 6", rowPath: "VR_Section_312_6_12" },
  ],
  section313: [
    { rowName: "Row 1", rowPath: "VR_Section_313_1_11" },
    { rowName: "Row 6", rowPath: "VR_Section_313_6_13" },
  ],
  section314: [
    { rowName: "Row 1", rowPath: "VR_Section_314_1_12" },
    { rowName: "Row 6", rowPath: "VR_Section_314_6_12" },
  ],
  section315: [
    { rowName: "Row 1", rowPath: "VR_Section_315_1_11" },
    { rowName: "Row 6", rowPath: "VR_Section_315_6_12" },
  ],
  section316: [
    { rowName: "Row 1", rowPath: "VR_Section_316_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_316_6_10" },
  ],
  section317: [
    { rowName: "Row 1", rowPath: "VR_Section_317_1_8" },
    { rowName: "Row 6", rowPath: "VR_Section_317_6_10" },
  ],
  section318: [
    { rowName: "Row 1", rowPath: "VR_Section_318_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_318_6_10" },
  ],
  section319: [
    { rowName: "Row 1", rowPath: "VR_Section_319_1_10" },
    { rowName: "Row 6", rowPath: "VR_Section_319_6_11" },
  ],
  section320: [
    { rowName: "Row 1", rowPath: "VR_Section_320_1_12" },
    { rowName: "Row 6", rowPath: "VR_Section_320_6_12" },
  ],
  section321: [
    { rowName: "Row 1", rowPath: "VR_Section_321_1_13" },
    { rowName: "Row 6", rowPath: "VR_Section_321_6_13" },
  ],
  section322: [
    { rowName: "Row 1", rowPath: "VR_Section_322_1_12" },
    { rowName: "Row 6", rowPath: "VR_Section_322_6_12" },
  ],
  section323: [
    { rowName: "Row 1", rowPath: "VR_Section_323_1_10" },
    { rowName: "Row 6", rowPath: "VR_Section_323_6_11" },
  ],
  section324: [
    { rowName: "Row 1", rowPath: "VR_Section_324_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_324_6_10" },
  ],
  section325: [
    { rowName: "Row 1", rowPath: "VR_Section_325_1_9" },
    { rowName: "Row 6", rowPath: "VR_Section_325_6_10" },
  ],
  section326: [
    { rowName: "Row 1", rowPath: "VR_Section_326_1_5" },
    { rowName: "Row 6", rowPath: "VR_Section_326_6_6" },
  ],
};
